import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=ae55d560&scoped=true&"
import script from "./SimpleTable.vue?vue&type=script&lang=ts&"
export * from "./SimpleTable.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=ae55d560&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae55d560",
  null
  
)

export default component.exports